//import logo from './logo.svg';
//import './App.css';
import Nav from './components/nav.jsx';
import Body from './components/body.jsx';

function App() {
  return (
    <>
    <Nav/>
    <Body/>
    </>
  );
}

export default App;
